import { render, staticRenderFns } from "./Anomalies-Admin.vue?vue&type=template&id=7dceb0a0&scoped=true"
import script from "./Anomalies-Admin.js?vue&type=script&lang=js&external"
export * from "./Anomalies-Admin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dceb0a0",
  null
  
)

export default component.exports